import * as React from "react";
function SvgRectangleFunnel(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M26 6v6h-2V6l-6-6h14l-6 6zm-3.172-4L25 4.171l2.171-2.17h-4.343zM29 28V12h2v18H1V9h20v2H3v17h26z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgRectangleFunnel);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
